var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCameraicon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#05cd78",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.48-7.48V8.371a7.48 7.48 0 0 1 7.48-7.48h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.48 7.481"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 25.25a4.381 4.381 0 1 1 .002-8.763A4.381 4.381 0 0 1 20 25.25m6.254-11.62h-2.16l-1.285-1.642h-5.286l-1.557 1.643h-2.22a2.795 2.795 0 0 0-2.794 2.794v8.793a2.794 2.794 0 0 0 2.794 2.793h12.508a2.794 2.794 0 0 0 2.794-2.793v-8.793a2.795 2.795 0 0 0-2.794-2.794"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.166 20.977a3.167 3.167 0 1 1-6.333 0 3.167 3.167 0 0 1 6.333 0"
}))));
export default SvgCameraicon;